import React, { useState, useEffect } from 'react';
import { sendContactEmail } from '../utils/emailClient';
import '../styles/contact.scss';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    street: '',
    houseNumber: '',
    postcode: '',
    stad: '',
    service: 'mechanische',
    message: '',
    contactMethod: 'email'
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  useEffect(() => {
    document.title = 'Contact - Fresh Air Care';
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      // Prepare template parameters with additional fields
      const templateParams = {
        from_name: formData.name,
        from_email: formData.email,
        phone: formData.phone,
        street: formData.street,
        house_number: formData.houseNumber,
        postcode: formData.postcode,
        stad: formData.stad,
        service_type: formData.service,
        message: formData.message,
        contact_method: formData.contactMethod,
        to_email: 'info@freshaircare.nl',
        reply_to: formData.email,
        year: new Date().getFullYear()
      };

      console.log('Sending email with params:', templateParams);

      // Send email using the EmailJS client
      const result = await sendContactEmail(templateParams);

      console.log('Email sent successfully:', result);
      setSubmitStatus('success');
      
      // Reset form
      setFormData({
        name: '',
        email: '',
        phone: '',
        street: '',
        houseNumber: '',
        postcode: '',
        stad: '',
        service: 'mechanische',
        message: '',
        contactMethod: 'email'
      });

    } catch (error) {
      console.error('Error sending email:', error);
      console.error('Error details:', {
        message: error.message,
        status: error.status,
        text: error.text
      });
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="contact-page">
      {/* ========== HERO ========== */}
      <section className="contact-hero">
        <div className="contact-container">
          <div className="contact-hero-content">
            <h1 className="contact-hero-title">
              Vraag een <span className="contact-accent">gratis offerte</span> aan
            </h1>
            <p className="contact-hero-description">
              Vul het formulier in en ontvang binnen 24 uur een vrijblijvende offerte op maat.
            </p>
          </div>
        </div>
      </section>

      {/* ========== CONTACT CONTENT ========== */}
      <section className="contact-content">
        <div className="contact-container">
          <div className="contact-grid">
            {/* Form Section */}
            <div className="contact-form-section">
              <div className="contact-form-header">
                <h2>Offerte Aanvraag</h2>
                <p>Vertel ons over je project en we helpen je graag verder</p>
              </div>

              <form className="contact-form" onSubmit={handleSubmit}>
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="name">Naam *</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      placeholder="Je volledige naam"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="email">E-mail *</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      placeholder="jouw@email.nl"
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="phone">Telefoonnummer *</label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      required
                      placeholder="06 12345678"
                    />
                  </div>
                </div>

                <div className="form-row form-row-address">
                  <div className="form-group">
                    <label htmlFor="street">Straat *</label>
                    <input
                      type="text"
                      id="street"
                      name="street"
                      value={formData.street}
                      onChange={handleChange}
                      required
                      placeholder="Bijv. Keizersgracht"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="houseNumber">Huisnummer *</label>
                    <input
                      type="text"
                      id="houseNumber"
                      name="houseNumber"
                      value={formData.houseNumber}
                      onChange={handleChange}
                      required
                      placeholder="Bijv. 42A"
                    />
                  </div>
                </div>

                <div className="form-row form-row-postcode">
                  <div className="form-group">
                    <label htmlFor="postcode">Postcode *</label>
                    <input
                      type="text"
                      id="postcode"
                      name="postcode"
                      value={formData.postcode}
                      onChange={handleChange}
                      required
                      placeholder="Bijv. 1012 AB"
                      autoComplete="postal-code"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="stad">Stad *</label>
                    <input
                      type="text"
                      id="stad"
                      name="stad"
                      value={formData.stad}
                      onChange={handleChange}
                      required
                      placeholder="Bijv. Amsterdam"
                      autoComplete="address-level2"
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="service">Type Service *</label>
                  <select
                    id="service"
                    name="service"
                    value={formData.service}
                    onChange={handleChange}
                    required
                  >
                    <option value="mechanische">Mechanische Ventilatie</option>
                    <option value="wtw">WTW Systemen</option>
                    <option value="dakventilatie">Dakventilatie</option>
                    <option value="onderhoud">Onderhoud</option>
                    <option value="reparatie">Reparatie</option>
                    <option value="anders">Anders</option>
                  </select>
                </div>

                <div className="form-group">
                  <label htmlFor="message">Bericht *</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    rows="6"
                    placeholder="Beschrijf je situatie en wat je nodig hebt..."
                  ></textarea>
                </div>
                {/* Status Messages */}
                {submitStatus === 'success' && (
                  <div className="form-status success">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" fill="currentColor"/>
                    </svg>
                    <span>Bedankt! Je aanvraag is succesvol verzonden. We nemen binnen 24 uur contact met je op.</span>
                  </div>
                )}

                {submitStatus === 'error' && (
                  <div className="form-status error">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" fill="currentColor"/>
                    </svg>
                    <span>Er is een fout opgetreden. Probeer het opnieuw of bel ons direct op 085 203 34 95.</span>
                  </div>
                )}

                <button 
                  type="submit" 
                  className="contact-submit-btn"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? 'Versturen...' : 'Verstuur Aanvraag'}
                </button>
              </form>
            </div>

            {/* Info Section */}
            <div className="contact-info-section">
              <div className="contact-info-card">
                <h3>Direct Contact</h3>
                <p>Liever direct contact? Bel of mail ons!</p>

                <div className="contact-info-items">
                  <div className="contact-info-item">
                    <div className="contact-info-icon">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" fill="currentColor"/>
                      </svg>
                    </div>
                    <div className="contact-info-text">
                      <span className="contact-info-label">Telefoon</span>
                      <span className="contact-info-value">085 203 34 95</span>
                    </div>
                  </div>

                  <div className="contact-info-item">
                    <div className="contact-info-icon">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" fill="currentColor"/>
                      </svg>
                    </div>
                    <div className="contact-info-text">
                      <span className="contact-info-label">E-mail</span>
                      <span className="contact-info-value">info@freshaircare.nl</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="contact-info-card">
                <h3>Waarom Fresh Air?</h3>
                <ul className="contact-benefits">
                  <li>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" fill="currentColor"/>
                    </svg>
                    <span>Gratis inspectie en advies</span>
                  </li>
                  <li>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" fill="currentColor"/>
                    </svg>
                    <span>Professionele installatie</span>
                  </li>
                  <li>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" fill="currentColor"/>
                    </svg>
                    <span>Tot 5 jaar garantie</span>
                  </li>
                  <li>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" fill="currentColor"/>
                    </svg>
                    <span>Vaste prijzen, geen verrassingen</span>
                  </li>
                  <li>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" fill="currentColor"/>
                    </svg>
                    <span>Reactie binnen 24 uur</span>
                  </li>
                </ul>
              </div>

              <div className="contact-info-card contact-hours">
                <h3>Openingstijden</h3>
                <div className="hours-list">
                  <div className="hours-item">
                    <span>Maandag - Vrijdag</span>
                    <span>08:30-18:00</span>
                  </div>
                  <div className="hours-item">
                    <span>Zaterdag</span>
                    <span>12:00 - 18:00</span>
                  </div>
                  <div className="hours-item">
                    <span>Zondag</span>
                    <span>Gesloten</span>
                  </div>  
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;